import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';
import useGetBots from '@webclient/hooks/useGetBots';

import { setBotByUserId } from '@webclient/state/slices/app-settings';
import { selectBot } from '@webclient/state/slices/app-settings/userSettingSelector';

import { Text } from '@knowz/knowz-ui';

export default function ModeSelector() {
  const { data: allBots } = useGetBots({
    limit: 100,
  });
  const bot = useAppSelector(selectBot);
  const me = useAppSelector((state) => state.auth.me);
  const dispatch = useAppDispatch();
  function handleSearchModeChange(e: SelectChangeEvent) {
    const foundBot = allBots?.data.find((bot) => bot.name === e.target.value);

    if (!foundBot || !me) return;
    dispatch(
      setBotByUserId({
        userId: me.uuid,
        bot: {
          id: foundBot.id,
          name: foundBot.name,
          image: foundBot.image,
        },
      }),
    );
  }

  return (
    <Select
      value={bot.name}
      onChange={handleSearchModeChange}
      variant="outlined"
    >
      {allBots?.data.map((bot) => (
        <MenuItem
          key={bot.id}
          value={bot.name}
        >
          <Text variant="textSm">{bot.name}</Text>
        </MenuItem>
      ))}
    </Select>
  );
}
